import React, { useEffect, useMemo, useRef, useState } from 'react'

const SNOWFLAKE_COUNT = 60
const DURATION_MS = 5000

const snowflakeData = Array.from({ length: SNOWFLAKE_COUNT }, (_, i) => ({
  id: i,
  left: `${(i * 1.67) % 100}%`,
  fontSize: `${10 + (i % 3) * 8}px`,
  animationDuration: `${1.5 + (i % 5) * 0.6}s`,
  animationDelay: `${(i % 10) * 0.2}s`,
}))

const styles = `
  @keyframes snowfall {
    0%   { transform: translateY(-20px) rotate(0deg); opacity: 1; }
    100% { transform: translateY(100vh) rotate(360deg); opacity: 0.4; }
  }
  @keyframes snowFadeOut {
    0%   { opacity: 1; }
    70%  { opacity: 1; }
    100% { opacity: 0; }
  }
`

export const SnowOverlay = () => (
  <>
    <style>{styles}</style>
    <div style={{
      position: 'fixed', top: 0, left: 0,
      width: '100vw', height: '100vh',
      pointerEvents: 'none', zIndex: 9999, overflow: 'hidden',
      animation: `snowFadeOut ${DURATION_MS / 1000}s linear forwards`,
    }}>
      {snowflakeData.map(flake => (
        <span key={flake.id} style={{
          position: 'absolute',
          top: '-20px',
          left: flake.left,
          fontSize: flake.fontSize,
          animation: `snowfall ${flake.animationDuration} linear ${flake.animationDelay} infinite`,
        }}>❄️</span>
      ))}
    </div>
  </>
)

export const useSnow = () => {
  const [snowActive, setSnowActive] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  const triggerSnow = () => {
    if (timer.current) clearTimeout(timer.current)
    setSnowActive(true)
    timer.current = setTimeout(() => setSnowActive(false), DURATION_MS)
  }

  useEffect(() => () => { if (timer.current) clearTimeout(timer.current) }, [])

  return { snowActive, triggerSnow }
}
